module.exports = __webpack_public_path__ + "img/back4.d5de929b.png";